var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.1,
    cy: 9.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d10000",
    r: 1.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 9.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d10000",
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2,
    cy: 9.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d10000",
    r: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 18.8h6.7c.4 0 .8 0 1.2-.1 2.1-.2 3.9-1.1 5.4-2.7 1.4-1.5 2.3-3.4 2.4-5.5.2-2.9-.8-5.3-2.8-7.1-2.4-2.2-5.2-2.9-8.2-2.2-2.3.5-4.1 1.7-5.4 3.8C2 6.9 1.5 9 1.9 11.3c.2 1.5.8 2.8 1.7 4 .2.3.3.5.3.9V18.8zm3.5.8H3.6c-.4 0-.5-.1-.5-.5v-2.8c0-.2 0-.4-.2-.5-1-1.3-1.6-2.8-1.9-4.4-.2-2.5.3-4.7 1.5-6.7C3.9 2.4 5.9 1 8.3.4c3.1-.8 6-.1 8.6 2.1 1.9 1.6 3 3.7 3.3 6.3.3 2.9-.6 5.5-2.4 7.6-1.6 1.8-3.5 2.8-5.8 3.1-.5.1-1 .1-1.5.1H7.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d10000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f8605900.svg";
export { ForwardRef as ReactComponent };